module.exports = __webpack_public_path__ + "img/58.78655f38.png";